export function getApiUsers ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/apiusers', { params: { page: page } })
      .then((response) => {
        if (response.data.apiusers) {
          commit('setApiUsers', response.data.apiusers)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getApiUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/apiusers/' + userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No api user id'))
    }
  })
}

export function getCreateApiUser ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/apiusers/create')
      .then((response) => {
        if (response.data.roles) {
          commit('setRoles', response.data.roles)
          resolve(response.data)
        } else {
          if (response && response.data && response.data.message) {
            reject(response.data.message)
          }
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createApiUser ({ state, commit }, { username, password, ip, active }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/apiusers', { username, password, ip, active })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditApiUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/apiusers/' + userId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No api user id'))
    }
  })
}

/* eslint-disable-next-line */
export function editApiUser ({ state, commit }, { id, username, password, ip, active }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/apiusers/' + id, { username, password, ip, active })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No api user id'))
    }
  })
}

export function deleteApiUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.delete('/v1/apiusers/' + userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No api user id'))
    }
  })
}
